let productVariantsInstance = null;
const quickVIew = (handle, e) => {

    e.closest('.ProductItem__Wrapper').classList.add('quick-view-opened');
    e.classList.add('quick-view-loading');
    e.classList.add('quick-view-spinner');

    fetch(`/products/${handle}?section_id=product-quick-view`)
        .then(res => res.text()) // Get the response as text
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            let modal = document.querySelector('.quickView_modal');
            const isOnlyOneVariant = doc.querySelector('.quick-view').getAttribute('data-only-variant');
            setTimeout(() => e.classList.remove('quick-view-spinner'), 500);
            if (isOnlyOneVariant === 'false') {
                modal.innerHTML = doc.querySelector('.quick-view__wrapper').innerHTML;
                modal.classList.add('active');
                document.querySelector('.PageOverlay').classList.add('is-visible');
                document.querySelector('html').classList.add('no-scroll');
                if (productVariantsInstance) {
                    productVariantsInstance.destroy();
                }
                productVariantsInstance = new ProductVariants(document.querySelector('.quickView_modal'), {});
            } else {
                const defaultVariant = doc.querySelector('.quick-view').getAttribute('data-default-variant');
                addToCart(e, Number(defaultVariant));
            }
        })
}

const closeQuickView = () => {
    let modal = document.querySelector('.quickView_modal');

    modal.classList.add('removing-modal');
    setTimeout(() => {
        modal.innerHTML = '';
        modal.classList.remove('active');
        modal.classList.remove('removing-modal');
        document.querySelector('.PageOverlay').classList.remove('is-visible');
    }, 500);
    document.querySelector('html').classList.remove('no-scroll');
    document.querySelector('.quick-view-opened')?.classList.remove('quick-view-opened');
    document.querySelector('.quick-view-loading')?.classList.remove('quick-view-loading');
    localStorage.removeItem('user_select');
}

document.body.addEventListener('click', (e) => {
    if (e.target.classList.contains('PageOverlay')) {
        closeQuickView();
    }
});

(function pollFor() {
    const startTime = Date.now();
    const maxDuration = 20000;

    function poll() {
        if (document.querySelector(`[data-section-type='recently-viewed-products'] .ProductItem__Title`)) {
            document.querySelectorAll(`[data-section-type='recently-viewed-products'] .ProductListWrapper .ProductItem`).forEach((item) => {
                const klaContainer = item.querySelector('.klaviyo-button-container');
                const handle = klaContainer.getAttribute('data-handle');
                const aTag = `<a class="btn klaviyo-bis-trigger" href="#" data-klaviyo-handle="${handle}"></a>`;
                klaContainer.innerHTML = aTag;
            });
        } else if (Date.now() - startTime < maxDuration) {
            setTimeout(poll, 25);
        }
    }

    poll();
})();




var ProductVariants = /*#__PURE__*/function () {
    function ProductVariants(container, options) {
        var _this = this;

        _classCallCheck(this, ProductVariants);

        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = options;
        var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
        var variantMetafieldsData = JSON.parse(this.element.querySelector('.quick-view')?.getAttribute('data-metafield'));
        this.variantMetafieldsData = JSON.parse(variantMetafieldsData);
        this.productData = jsonData['product'];
        this.variantsInventories = jsonData['inventories'] || {};
        this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData['id'])); // We init value with the first selected variant

        this.productData['variants'].forEach(function (variant) {
            if (variant['id'] === jsonData['selected_variant_id']) {
                _this.currentVariant = variant;
                _this.option1 = variant['option1'];
                _this.option2 = variant['option2'];
                _this.option3 = variant['option3'];
            }
        });


        this._attachListeners();
        this._createSelectors();

    }

    _createClass(ProductVariants, [{
        key: "destroy",
        value: function destroy() {
            // Remove all event listeners
            this.delegateElement.off('click', '.quick-view_atc [data-action="add-to-cart"]', this._addToCart.bind(this));
            this.delegateElement.off('click', '.klaviyo-btn', this._klaviyoEmail.bind(this));
            this.delegateElement.off('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));

            this.formPopovers.forEach(function (popover) {
                popover.destroy();
            });
            this.formVariantSelectors.forEach(function (selector) {
                selector.destroy();
            });

            this.formPopovers = [];
            this.formVariantSelectors = [];
            this.delegateElement.destroy();
            this.delegateElement = null;
            this.element = null;
            this.options = null;
            this.currentVariant = null;
            this.variantMetafieldsData = null;
            this.productData = null;
            this.variantsInventories = null;
            this.masterSelector = null;
        }
    }, {
        key: "_attachListeners",
        value: function _attachListeners() {
            this.delegateElement.on('click', '.quick-view_atc [data-action="add-to-cart"]', this._addToCart.bind(this));
            this.delegateElement.on('click', '.klaviyo-btn', this._klaviyoEmail.bind(this));
            this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
        }
        /**
         * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
         */

    }, {
        key: "_createSelectors",
        value: function _createSelectors() {
            var _this2 = this;

            // Create the instances for each selector
            this.formPopovers = [];
            this.formVariantSelectors = [];
            Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
                var popover = new Popover(item, {
                    preferredPosition: 'left',
                    onValueChanged: _this2._onOptionChanged.bind(_this2)
                });

                _this2.formPopovers.push(popover);
            });
            Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (item) {
                var variantSelector = new VariantSelector(item, _this2, {
                    onValueChanged: _this2._onOptionChanged.bind(_this2)
                });

                _this2.formVariantSelectors.push(variantSelector);
            });
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
         *
         * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
         * edit this code
         * ---------------------------------------------------------------------------------------------------
         */

        /**
         * This callback is called whenever the variant changes and allows to update data about the active variant
         */

    }, {
        key: "_onVariantChanged",
        value: function _onVariantChanged(previousVariant, newVariant) {
            // 1st: the prices
            this._updateProductPrices(newVariant, previousVariant);
            this._updateAddToCartButton(newVariant, previousVariant);
            this._updateMedia(newVariant, previousVariant);
            this._updateTitle(newVariant, previousVariant);

        }
        /**
         * Update the prices (optionally showing compare at price)
         */

    }, {
        key: "_updateMedia",
        value: function _updateMedia(newVariant) {
            const element = this.element;
            this.productData['variants'].forEach(function (variant) {
                if (variant?.id === newVariant?.id) {
                    var image = variant['featured_image'];
                    if(image){
                        element.querySelector('.quick-show').classList.add('quick-hide');
                        element.querySelector('.quick-show').classList.remove('quick-show');
                        element.querySelectorAll('.quick-view__media img').forEach(function (img) {
                            const imgVariantId = img.getAttribute('data-variant-id');
                            if(imgVariantId == variant.id){
                                img.classList.remove('quick-hide');
                                img.classList.add('quick-show');
                            }
                        });
                    }
                }
            });

        }

    },
    {
        key: "_updateTitle",
        value: function _updateTitle(newVariant) {
            const element = this.element;
            const variants = this.productData['variants'];
            this.variantMetafieldsData.forEach(function (variant) {
                if (variant?.id == newVariant?.id) {
                    var title = variant['new-title'];
                    if (title) {
                        element.querySelector('.quick-view__title a').innerHTML = title;
                    }
                    
                    if(element.querySelector('.UnitPriceMeasurement__Price')){
                        element.querySelector('.UnitPriceMeasurement__Price').textContent = Currency.formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
                        element.querySelector('.UnitPriceMeasurement__ReferenceValue').textContent = newVariant['unit_price_measurement']['reference_unit'];
                        element.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_value'];
                    }

                    element.querySelector('.quick-view__title a').href = variant['url'];
                    element.querySelector('.quick-view__media a').href = variant['url'];
                    localStorage.setItem('user_select', variant.id);
                    const newVariant_option1 = newVariant['option1'];

                    variants.forEach(function (variant) {
                        if (variant['option1'] == newVariant_option1) {
                            if(variant['available'] == false){
                                document.querySelectorAll('.SizeSwatch').forEach(function (swatch) {
                                    if(swatch.textContent.trim() == variant['option2']){
                                        swatch.classList.add('soldout-border');
                                        swatch.closest('li').classList.add('sold-out');
                                    }
                                });
                            }else{
                                document.querySelectorAll('.SizeSwatch').forEach(function (swatch) {
                                    if(swatch.textContent.trim() == variant['option2']){
                                        swatch.classList.remove('soldout-border');
                                        swatch.closest('li').classList.remove('sold-out');
                                    }
                                });
                            }
                        }
                    });

                }
            });

        }
    },
    {
        key: "_updateProductPrices",
        value: function _updateProductPrices(newVariant, previousVariant) {
            var productMetaPrices = this.element.querySelector('.ProductMeta__PriceList');

            if (!newVariant) {
                productMetaPrices.style.display = 'none';
            } else {
                if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
                    return; // The price do not have changed so let's return to avoid changing the DOM for nothing
                }

                productMetaPrices.innerHTML = '';

                if (newVariant['compare_at_price'] > newVariant['price']) {
                    productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--highlight \" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), " inkl. MwSt.</span>");
                    productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--compareAt \" data-money-convertible>".concat(Currency.formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat), " inkl. MwSt.</span>");
                } else {
                    productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price \" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), " inkl. MwSt.</span>");
                }

                productMetaPrices.style.display = '';
            }
        }
        /**
         * Update the inventory (if needed)
         */

    }, {
        key: "_updateAddToCartButton",
        value: function _updateAddToCartButton(newVariant) {
            var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
                isPreOrder = addToCartButton.classList.contains("preorder_atc"),
                klaBtn = this.element.querySelector(".klaviyo-btn"),
                deliveryMSG = this.element.querySelector("#delivery_text_wrapper"),
                shopifyPaymentButton = this.element.querySelector('.shopify-payment-button');
            availableMsg = `<div class="delivery-available"><i class="fa fa-check" style="margin-right: 4px;"></i><span>sofort lieferbar, in 1-3 Tagen bei Ihnen</span></div>`;
            addToCartButton.classList.remove('Button--secondary');
            addToCartButton.classList.remove('Button--primary');
            if (!newVariant) {
                addToCartButton.setAttribute('disabled', 'disabled');
                addToCartButton.removeAttribute('data-action');
                addToCartButton.classList.add('Button--secondary');
                addToCartButton.innerHTML = window.languages.productFormUnavailable;
                deliveryMSG.innerHTML = availableMsg;
            } else {
                if (newVariant['available'] || isPreOrder) {
                    addToCartButton.removeAttribute('disabled');
                    addToCartButton.style.display = 'block';
                    klaBtn.style.display = 'none';
                    addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
                    addToCartButton.setAttribute('data-action', 'add-to-cart');

                    var atc_text = isPreOrder ? window.languages.productFormAddToCartPreorder : window.languages.productFormAddToCart;
                    if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
                        addToCartButton.innerHTML = "\n            <span>".concat(atc_text, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span data-money-convertible>").concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), "</span>\n          ");
                        deliveryMSG.innerHTML = availableMsg;
                    } else {
                        addToCartButton.innerHTML = "<span>".concat(atc_text, "</span>");
                        deliveryMSG.innerHTML = availableMsg;
                    }
                } else {
                    addToCartButton.setAttribute('disabled', 'disabled');
                    addToCartButton.classList.add('Button--secondary');
                    addToCartButton.removeAttribute('data-action');
                    addToCartButton.innerHTML = window.languages.productFormSoldOut;
                    addToCartButton.style.display = 'none';
                    klaBtn.style.display = 'block';
                    deliveryMSG.innerHTML = `<div class="delivery-not-available"><i class="fa fa-times" style="margin-right: 4px;"></i><span>bald wieder für Sie verfügbar</span></div>`;
                }
            }

            if (this.options['showPaymentButton'] && shopifyPaymentButton) {
                if (!newVariant || !newVariant['available']) {
                    shopifyPaymentButton.style.display = 'none';
                } else {
                    shopifyPaymentButton.style.display = 'block';
                }
            }
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * INTERNAL CODE THAT HANDLE VARIANT CHANGES
         * ---------------------------------------------------------------------------------------------------
         */

        /**
         * Whenever an option is changed, this code fetch the corresponding active variant
         */

    }, {
        key: "_onOptionChanged",
        value: function _onOptionChanged(newValue, target, activator) {
            // We change the value associated with the activator, and check if we have a color swatch
            if (activator) {
                this['option' + target.getAttribute('data-option-position')] = newValue;
                activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
            } else {
                this['option' + target.getAttribute('data-option-position')] = target.value;
                var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

                if (selectedValue) {
                    selectedValue.innerHTML = target.value;
                }
            } // Finally, we get the new variant


            var previousVariant = this.currentVariant;
            this.currentVariant = this._getCurrentVariantFromOptions();


            this._onVariantChanged(previousVariant, this.currentVariant);

            if (this.currentVariant) {
                if (this.options['enableHistoryState']) {
                    this._updateHistoryState(this.currentVariant);
                } // We need to modify the hidden select that contain the id attribute as well


                this.masterSelector.querySelector('[selected]').removeAttribute('selected');
                this.masterSelector.querySelector("[value=\"".concat(this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
                this.masterSelector.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
        }
        /**
         * Get the active variant based on the options
         */

    }, {
        key: "_getCurrentVariantFromOptions",
        value: function _getCurrentVariantFromOptions() {
            var _this3 = this;

            var found = false;
            this.productData['variants'].forEach(function (variant) {
                if (variant['option1'] === _this3.option1 && variant['option2'] === _this3.option2 && variant['option3'] === _this3.option3) {
                    found = variant;
                }
            });
            return found || null;
        }
        /**
         * Update the history state for browsers that support it
         */

    }, {
        key: "_addToCart",
        value: function _addToCart(event) {
            var _this4 = this;


            event.preventDefault(); // Prevent form to be submitted

            var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'); // First, we switch the status of the button

            addToCartButton.setAttribute('disabled', 'disabled');
            document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

            var formElement = this.element.querySelector('form[action*="/cart/add"]');
            fetch("".concat(window.routes.cartAddUrl, ".js"), {
                body: JSON.stringify(Form.serialize(formElement)),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

                }
            }).then(function (response) {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                var quantityElement = formElement.querySelector('[name="quantity"]');
                closeQuickView();

                if (response.ok) {
                    addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

                    _this4.element.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            variant: _this4.currentVariant,
                            quantity: quantityElement ? parseInt(quantityElement.value) : 1
                        }
                    }));
                } else {
                    response.json().then(function (content) {
                        var errorMessageElement = document.createElement('span');
                        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                        errorMessageElement.innerHTML = content['description'];
                        addToCartButton.removeAttribute('disabled');
                        addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                        setTimeout(function () {
                            errorMessageElement.remove();
                        }, 2500);
                    });
                }
            });
            event.preventDefault();
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * OTHER
         * ---------------------------------------------------------------------------------------------------
         */

        /**
         * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
         */

    }, {

        key: "_klaviyoEmail",
        value: function _klaviyoEmail(event, target) {
            let quickBtnElm = document.querySelector('.quick-view-opened');
            quickBtnElm.querySelector('.klaviyo-bis-trigger').click();
            let iframe = document.getElementById('klaviyo-bis-iframe');
            let iframeDoc = iframe.contentWindow.document;
            let selectedID = document.querySelector('.ProductForm__Option select').value;
            const variantMetafieldsData = this.variantMetafieldsData;

            (function pollFor() {
                if (iframe && iframeDoc && iframeDoc.querySelector('body .modal-title')) {
                    closeQuickView();
                    variantMetafieldsData.forEach(function (variant) {
                        if (variant['id'] == selectedID) {
                            var title = variant['new-title'];
                            if (title) {
                                iframeDoc.querySelector('body .modal-title').textContent = title;
                            }
                        }
                    });
                    iframeDoc.querySelector('#variants').addEventListener('change', (e) => {
                        let varinatValue = e.target.selectedOptions[0].value;
                        let selectedVariant = variantMetafieldsData.find(function (variant) {
                            return variant['id'] == varinatValue;
                        });
                        iframeDoc.querySelector('body .modal-title').textContent = selectedVariant['new-title'];
                    });
                } else {
                    setTimeout(pollFor, 25);
                }
            })();

        }

    }
    ]);

    return ProductVariants;
}();

var addToCart = (element, defaultVariant) => {


    var addToCartButton = element; // First, we switch the status of the button

    addToCartButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

    const body = {
        id: defaultVariant,
        quantity: 1
    }
    fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: JSON.stringify(body),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
    }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        closeQuickView();

        if (response.ok) {
            addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

            element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: defaultVariant,
                    quantity: 1
                }
            }));
        } else {
            response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                    errorMessageElement.remove();
                }, 2500);
            });
        }
    });
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var Dom = /*#__PURE__*/function () {
    function Dom() {
        _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [{
        key: "getSiblings",
        value:
            /**
             * Get all the previous and next siblings, optionally filtered by a selector
             */
            function getSiblings(element, filter) {
                var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var siblings = [];
                var currentElement = element; // Do the previous first

                while (currentElement = currentElement.previousElementSibling) {
                    if (!filter || currentElement.matches(filter)) {
                        siblings.push(currentElement);
                    }
                }

                if (includeSelf) {
                    siblings.push(element);
                } // Then the next side


                currentElement = element;

                while (currentElement = currentElement.nextElementSibling) {
                    if (!filter || currentElement.matches(filter)) {
                        siblings.push(currentElement);
                    }
                }

                return siblings;
            }
        /**
         * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
         * we need to normalize it
         */

    }, {
        key: "nodeListToArray",
        value: function nodeListToArray(nodeList, filter) {
            var items = [];

            for (var i = 0; i !== nodeList.length; ++i) {
                if (!filter || nodeList[i].matches(filter)) {
                    items.push(nodeList[i]);
                }
            }

            return items;
        }
        /**
         * Calculate an element width with its margin
         */

    }, {
        key: "outerWidthWithMargin",
        value: function outerWidthWithMargin(element) {
            var width = element.offsetWidth,
                style = getComputedStyle(element);
            width += parseInt(style.marginLeft) + parseInt(style.marginRight);
            return width;
        }
        /**
         * Calculate an element height with its margin
         */

    }, {
        key: "outerHeightWithMargin",
        value: function outerHeightWithMargin(element) {
            var height = element.offsetHeight,
                style = getComputedStyle(element);
            height += parseInt(style.marginTop) + parseInt(style.marginBottom);
            return height;
        }
    }]);

    return Dom;
}();

var Currency = /*#__PURE__*/function () {
    function Currency() {
        _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
        key: "formatMoney",
        value:
            /**
             * Format money values based on your shop currency settings
             *
             * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
             * @param  {String} format - shop money_format setting
             * @return {String} value - formatted value
             */
            function formatMoney(cents, format) {
                if (typeof cents === 'string') {
                    cents = cents.replace('.', '');
                }

                var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                    formatString = format || '${{amount}}';

                function defaultTo(value, defaultValue) {
                    return value == null || value !== value ? defaultValue : value;
                }

                function formatWithDelimiters(number, precision, thousands, decimal) {
                    precision = defaultTo(precision, 2);
                    thousands = defaultTo(thousands, ',');
                    decimal = defaultTo(decimal, '.');

                    if (isNaN(number) || number == null) {
                        return 0;
                    }

                    number = (number / 100.0).toFixed(precision);
                    var parts = number.split('.'),
                        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                        centsAmount = parts[1] ? decimal + parts[1] : '';
                    return dollarsAmount + centsAmount;
                }

                var value = '';

                switch (formatString.match(placeholderRegex)[1]) {
                    case 'amount':
                        value = formatWithDelimiters(cents, 2);
                        break;

                    case 'amount_no_decimals':
                        value = formatWithDelimiters(cents, 0);
                        break;

                    case 'amount_with_space_separator':
                        value = formatWithDelimiters(cents, 2, ' ', '.');
                        break;

                    case 'amount_no_decimals_with_comma_separator':
                        value = formatWithDelimiters(cents, 0, ',', '.');
                        break;

                    case 'amount_no_decimals_with_space_separator':
                        value = formatWithDelimiters(cents, 0, ' ');
                        break;

                    case 'amount_with_comma_separator':
                        value = formatWithDelimiters(cents, 2, '.', ',');
                        break;
                }

                if (formatString.indexOf('with_comma_separator') !== -1) {
                    return formatString.replace(placeholderRegex, value).replace(',00', '');
                } else {
                    return formatString.replace(placeholderRegex, value).replace('.00', '');
                }
            }
    }]);

    return Currency;
}();

var Form = /*#__PURE__*/function () {
    function Form() {
        _classCallCheck(this, Form);
    }

    _createClass(Form, null, [{
        key: "serialize",
        value: function serialize(form) {
            function stringKey(key, value) {
                var beginBracket = key.lastIndexOf('[');

                if (beginBracket === -1) {
                    var _hash = {};
                    _hash[key] = value;
                    return _hash;
                }

                var newKey = key.substr(0, beginBracket);
                var newValue = {};
                newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
                return stringKey(newKey, newValue);
            }

            var hash = {};

            for (var i = 0, len = form.elements.length; i < len; i++) {
                var formElement = form.elements[i];

                if (formElement.name === '' || formElement.disabled) {
                    continue;
                }

                if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
                    var stringKeys = stringKey(formElement.name, formElement.value);
                    hash = Form.extend(hash, stringKeys);
                }
            }

            return hash;
        }
    }, {
        key: "extend",
        value: function extend() {
            var extended = {};
            var i = 0; // Merge the object into the extended object

            var merge = function merge(obj) {
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        // If property is an object, merge properties
                        if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                            extended[prop] = Form.extend(extended[prop], obj[prop]);
                        } else {
                            extended[prop] = obj[prop];
                        }
                    }
                }
            }; // Loop through each object and conduct a merge


            for (; i < arguments.length; i++) {
                merge(arguments[i]);
            }

            return extended;
        }
    }]);

    return Form;
}();




